// 회원 로그인 토큰 저장소 (localStorage)

const TOKEN_KEY = "mdl_token";

export function getMemberToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setMemberToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* 저장 실패 무시 */
  }
}

export function clearMemberToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* 삭제 실패 무시 */
  }
}